import { FC } from "react";

export interface CheckboxAsRadioProps {
  label?: string;
  subLabel?: string;
  className?: string;
  checked?: boolean;
  name: string;
  value: any;
  defaultChecked?: boolean;
  onChange?: (value: any) => void;
  disabled?: boolean;
}

const CheckboxAsRadio: FC<CheckboxAsRadioProps> = ({
  subLabel = "",
  label = "",
  name,
  value,
  className = "",
  defaultChecked,
  checked,
  disabled = false,
  onChange,
}) => {
  return (
    <div
      className={`flex text-sm sm:text-base ${className}`}
      style={{ cursor: disabled ? "not-allowed" : "pointer" }}
    >
      <input
        disabled={disabled}
        id={value}
        name={name}
        type="checkbox"
        className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
        value={value}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={(e) => {
          if (onChange && !disabled) {
            onChange(value);
          }
        }}
      />
      {label && (
        <label
          htmlFor={value}
          className="ml-3.5 flex flex-col flex-1 justify-center"
        >
          <span className=" text-neutral-900 dark:text-neutral-100">
            {label}
          </span>
          {subLabel && (
            <p className="mt-1 text-neutral-500 dark:text-neutral-400 text-sm font-light">
              {subLabel}
            </p>
          )}
        </label>
      )}
    </div>
  );
};

export default CheckboxAsRadio;
